import { useDispatch } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

// export const useAppDispatch: () => AppDispatch = useDispatch;
const useAppDispatch: () => ThunkDispatch<{}, void, Action> = () => useDispatch();

export default useAppDispatch;
